export enum AvatarPosition {
    Left = "tl",
    Right = "tr"
  }
  